<template>
  <v-btn
    v-if="showSearchAppButton && !mobileMenuMode"
    icon
    class="d-none d-sm-flex"
  >
    <v-icon 
      :icon="mdiMagnify"
      color="base-white"
    />

    <v-tooltip
      activator="parent"
      location="bottom"
    >
      <span>{{ tooltip }}</span>
    </v-tooltip>

    <v-dialog
      activator="parent"
      max-width="600"
      min-height="800"
      max-height="800"
    >
      <template #default="{ isActive }">
        <v-card rounded="lg">
          <v-card-title class="d-flex justify-space-between align-center">
            <!-- //TODO: Implement i18n later -->
            <div>Search through CRV apps, still needs to be implemented.</div>
            <v-btn
              :icon="mdiClose"
              variant="text"
              @click="isActive.value = false"
            />
          </v-card-title>
        </v-card>
      </template>
    </v-dialog>
  </v-btn>

  <v-list-item
    v-else-if="showSearchAppButton && mobileMenuMode"
    role="button"
    link
  >
    <template #prepend>
      <v-icon :icon="mdiMagnify" />
    </template>
    <v-list-item-title>{{ tooltip }}</v-list-item-title>

    <v-dialog
      activator="parent"
      fullscreen
    >
      <template #default="{ isActive }">
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <!-- //TODO: Implement i18n later -->
            <div>Search through CRV apps, still needs to be implemented.</div>
            <v-btn
              :icon="mdiClose"
              variant="text"
              @click="isActive.value = false"
            />
          </v-card-title>
        </v-card>
      </template>
    </v-dialog>
  </v-list-item>
</template>


<script>
import { mdiMagnify, mdiClose } from '@mdi/js'

export default {
    name: 'CrvSearchApp',

    props: {
      showSearchAppButton: {
        type: Boolean,
        default: false,
      },

      tooltip: {
        type: String,
        // default: `${searchApps}`, //TODO: Implement i18n later
        default: 'Search through CRV apps',
      },

      mobileMenuMode: {
        type: Boolean,
        default: false,
        note: `Shows a list-item instead of a button when in mobile menu mode`,
      },       
    },

    data() {
        return {
          mdiMagnify,
          mdiClose
        }
    },
}
</script>